exports.init = () => 0;
exports.add = (a, v) => (!isNaN(parseFloat(v)) && isFinite(v)) ? a + v : a;
exports.get = v => v;